@let hideErrorMessages = config?.responseConfig?.hideErrorMessages;

<xm-maintenance-view></xm-maintenance-view>
<xm-page-ribbon></xm-page-ribbon>
@if (!hideErrorMessages) {
  <xm-error-messages></xm-error-messages>
}
<xm-password-needed></xm-password-needed>

<xm-heatmap-container>
    <div class="wrapper {{isGuestLayout ? 'xm-guest-layout' : 'xm-auth-layout'}}"
         navigationClass
         id="main-content-wrapper"
    >
      <div xmGuestBackground></div>
      <xm-layout-wrapper
        [isGuestLayout]="isGuestLayout"
      >
        <div *ngIf="resolved$ | async"
             class="main-panel xm-main-panel"
             [ngClass]="{'has-backdrop': showSidebarBackdrop}"
             [style.margin-right]="sidebarContentSpacer"
             id="main">

          <xm-top-panel *ngIf="config?.topPanel?.position === 'on-top'"></xm-top-panel>

          <xm-loader [absolute]="true" routerLoading></xm-loader>

          <xm-navbar class="mb-3" [ngClass]="{'relative-position': isSidenavOpen$ | async}"></xm-navbar>

          <xm-top-panel *ngIf="config?.topPanel?.position === 'before-dashboard-content'"></xm-top-panel>

          <div [ngClass]="(isGuestLayout && !config.fullWidth) ? 'container' : 'container-fluid'"
               class="main-content xm-main-content">
            <router-outlet></router-outlet>
          </div>

          <router-outlet name="popup"></router-outlet>

          <xm-footer></xm-footer>
        </div>

      </xm-layout-wrapper>
      <xm-sidebar-right></xm-sidebar-right>
    </div>
</xm-heatmap-container>
